import { analyticsActions } from '../../services';
import ReactGA from 'react-ga';
let trackingId = undefined;
const unitializedCalls = [];

const handleUninitializedCalls = (dispatch, tId ) => () => {
  trackingId = tId;
  return Promise.all( unitializedCalls.map( arg => dispatch( arg ) ) ).then( () => unitializedCalls.splice(0, unitializedCalls.length ) );
}

const setClientId = ( dispatch, trackerName ) => {
  //dimension1 maps to 'ClientId'
  return ReactGA.ga(tracker => dispatch( { type: analyticsActions.SET, data: { 'dimension1' :  tracker.get('clientId')}, names: trackerName }))
}

const sendData = dispatch => eventData => {
  if ( !trackingId ) {
    unitializedCalls.push( eventData );
    return Promise.resolve( true );
  }
  return dispatch( eventData );
}

export const analyticsDispatcher = dispatch => ( {
  initializeGA: ( trackingId ) => dispatch( { type: analyticsActions.INIT, trackingId } ).then(setClientId( dispatch )).then( handleUninitializedCalls( dispatch, trackingId ) ),
  initializeGACommon: ( trackingId ) => dispatch( { type: analyticsActions.INITCOMMON, trackingId } ).then(setClientId( dispatch, 'commonTracker' )).then( handleUninitializedCalls( dispatch, trackingId ) ),
  captureEvent: ( category, action, label, trackerName ) => sendData( dispatch )( { type: analyticsActions.EVENT, data: { category, action, label }, names: trackerName } ),
  capturePageView: ( page, names, title ) => sendData( dispatch )( { type: analyticsActions.PAGEVIEW, page, names, title } )
  
} );